import { Steps } from 'antd'

import { SUBJECT_STATUS_ENUM } from '../../../Types'
import { buildSteps, getCurrentStep } from '../../../util/subject-journey'

export const StepsComponent = ({ phasesData, subjectData }) => {
  const currentStep = getCurrentStep(phasesData, subjectData)
  const items = buildSteps(phasesData, subjectData)

  const subjectStatus = subjectData.status === SUBJECT_STATUS_ENUM.TERMINATED ? 'error' : 'process'

  return (
    <>
      <Steps
        type="dot"
        orientation="vertical"
        status={subjectStatus}
        current={subjectData.status === SUBJECT_STATUS_ENUM.COMPLETED ? currentStep + 1 : currentStep}
        items={items}
      />
    </>
  )
}

/*
const AnimatedDot = ({ index, currentStep, subjectStatus }) => {
  const { spring, animated } = useStaggerFadeIn(index)

  if (index === currentStep) {
    return (
      <animated.div
        className={`border rounded-circle  ${subjectStatus === 'error' ? 'border-danger' : 'border-primary'} `}
        style={{ marginLeft: -2, width: 14, height: 14, padding: 2, ...spring }}
      >
        <div className={`rounded-circle w-100 h-100 ${subjectStatus === 'error' ? 'bg-danger' : 'bg-primary'} `}></div>
      </animated.div>
    )
  }

  return index <= currentStep ? (
    <animated.div
      className="rounded-circle bg-primary "
      style={{ marginTop: 1, marginLeft: 1, width: 8, height: 8, ...spring }}
    ></animated.div>
  ) : (
    <animated.div
      className="rounded-circle  "
      style={{ marginLeft: 2, width: 8, height: 8, backgroundColor: COLOR.DARK_GRAY, ...spring }}
    ></animated.div>
  )
}
*/
